(function () {
  const BODY_MENU_OPEN = 'product-gallery-mobile-menu-open';

  let bodyScrollY = 0;

  function lockBodyScroll() {
    if (document.body.classList.contains(BODY_MENU_OPEN)) return;
    bodyScrollY = window.scrollY;
    document.body.classList.add(BODY_MENU_OPEN);
    document.body.style.position = 'fixed';
    document.body.style.top = `-${bodyScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    if (!document.body.classList.contains(BODY_MENU_OPEN)) return;
    document.body.classList.remove(BODY_MENU_OPEN);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, bodyScrollY);
  }

  function closeMenu(root) {
    const menu = root.querySelector('[data-gallery-actions-menu]');
    const backdrop = root.querySelector('[data-gallery-actions-backdrop]');
    const fab = root.querySelector('[data-gallery-actions-toggle]');
    const closeFab = root.querySelector('[data-gallery-actions-close]');
    if (menu) menu.hidden = true;
    if (backdrop) backdrop.hidden = true;
    if (closeFab) closeFab.hidden = true;
    if (fab) {
      fab.hidden = false;
      fab.setAttribute('aria-expanded', 'false');
    }
    unlockBodyScroll();
  }

  function openMenu(root) {
    const menu = root.querySelector('[data-gallery-actions-menu]');
    const backdrop = root.querySelector('[data-gallery-actions-backdrop]');
    const fab = root.querySelector('[data-gallery-actions-toggle]');
    const closeFab = root.querySelector('[data-gallery-actions-close]');
    lockBodyScroll();
    if (backdrop) backdrop.hidden = false;
    if (menu) menu.hidden = false;
    if (fab) {
      fab.hidden = true;
      fab.setAttribute('aria-expanded', 'true');
    }
    if (closeFab) closeFab.hidden = false;
  }

  function isMenuOpen(root) {
    const menu = root.querySelector('[data-gallery-actions-menu]');
    return menu && !menu.hidden;
  }

  function isBookmarkHintOpen(root) {
    const hint = root.querySelector('[data-browser-bookmark-hint]');
    return hint && !hint.hidden;
  }

  function openBookmarkHint(root) {
    closeMenu(root);
    const hint = root.querySelector('[data-browser-bookmark-hint]');
    if (hint) hint.hidden = false;
  }

  function closeBookmarkHint(root) {
    const hint = root.querySelector('[data-browser-bookmark-hint]');
    if (hint) hint.hidden = true;
  }

  async function shareProduct(root) {
    const title = root.dataset.productTitle || document.title;
    const url = root.dataset.productUrl || window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ title, text: title, url });
      } catch (e) {
        if (e && e.name !== 'AbortError') {
          copyUrl(url);
        }
      }
    } else {
      copyUrl(url);
    }
    closeMenu(root);
  }

  function copyUrl(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url);
    }
  }

  function init(root) {
    root.querySelector('[data-gallery-actions-toggle]')?.addEventListener('click', () => {
      const menu = root.querySelector('[data-gallery-actions-menu]');
      if (menu?.hidden) {
        openMenu(root);
      } else {
        closeMenu(root);
      }
    });

    root.querySelector('[data-gallery-actions-close]')?.addEventListener('click', () => closeMenu(root));
    root.querySelector('[data-gallery-actions-backdrop]')?.addEventListener('click', () => closeMenu(root));

    root.querySelector('[data-gallery-action="share"]')?.addEventListener('click', () => shareProduct(root));
    root.querySelector('[data-gallery-action="compare"]')?.addEventListener('click', () => closeMenu(root));
    root.querySelector('[data-gallery-action="bookmark"]')?.addEventListener('click', () => openBookmarkHint(root));

    root.querySelectorAll('[data-browser-bookmark-hint-close]').forEach((btn) => {
      btn.addEventListener('click', () => closeBookmarkHint(root));
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-product-gallery-mobile-actions]').forEach((root) => {
      if (isBookmarkHintOpen(root)) {
        closeBookmarkHint(root);
      } else if (isMenuOpen(root)) {
        closeMenu(root);
      }
    });
  });

  function boot() {
    document.querySelectorAll('[data-product-gallery-mobile-actions]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
